import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import DashboardLayout from "@/components/DashboardLayout";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Triangle, Circle, Square, Diamond, Clock, Loader2, ArrowLeft, CheckCircle2 } from "lucide-react";

const shapes = [Triangle, Diamond, Circle, Square];
const colors = ["bg-brand-blue", "bg-brand-purple", "bg-brand-green", "bg-brand-yellow"];

export default function QuizVisualizar() {
  const { id } = useParams();
  const [quiz, setQuiz] = useState(null);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.get(`/quizzes/${id}`).then((r) => setQuiz(r.data)).catch(() => setQuiz(null));
  }, [id]);

  if (!quiz) {
    return (
      <DashboardLayout>
        <div className="flex justify-center py-20"><Loader2 className="w-7 h-7 animate-spin text-brand-blue" /></div>
      </DashboardLayout>
    );
  }

  const q = quiz.questions[idx];

  return (
    <DashboardLayout>
      <div className="flex items-center justify-between">
        <Link to={`/quiz/${id}/editar`}>
          <Button variant="ghost" className="rounded-full gap-2"><ArrowLeft className="w-4 h-4" /> Voltar ao editor</Button>
        </Link>
        <span className="text-sm text-brand-muted">Questão {idx + 1} de {quiz.questions.length}</span>
      </div>

      <div className="mt-4 rounded-3xl bg-brand-ink p-6 sm:p-10 text-white">
        <p className="text-sm text-white/60 uppercase tracking-widest font-bold">{quiz.title}</p>
        <div className="mt-4 flex items-center justify-between">
          <span className="inline-flex items-center gap-1.5 bg-white/10 px-3 py-1.5 rounded-full text-sm"><Clock className="w-4 h-4" /> {q.time_limit}s</span>
          <span className="text-white/60 text-sm">{q.points} pts</span>
        </div>
        <h2 className="mt-6 font-heading text-2xl sm:text-3xl font-black text-center min-h-[3rem]">{q.question}</h2>

        <div className="mt-8 grid sm:grid-cols-2 gap-3">
          {q.options.map((opt, oi) => {
            const Shape = shapes[oi % 4];
            const correct = q.correct_answers.includes(oi);
            return (
              <div
                key={oi}
                className={`relative flex items-center gap-3 p-5 rounded-2xl text-white font-semibold ${colors[oi % 4]} ${correct ? "ring-4 ring-white" : "opacity-90"}`}
                data-testid={`preview-option-${oi}`}
              >
                <Shape className="w-6 h-6 shrink-0" fill="white" />
                <span className="text-lg">{opt}</span>
                {correct && <CheckCircle2 className="w-6 h-6 ml-auto" />}
              </div>
            );
          })}
        </div>

        {q.explanation && (
          <div className="mt-6 bg-white/10 rounded-2xl p-4 text-sm text-white/90">
            <strong>Explicação:</strong> {q.explanation}
          </div>
        )}
      </div>

      <div className="mt-5 flex justify-between">
        <Button variant="outline" disabled={idx === 0} onClick={() => setIdx(idx - 1)} className="rounded-full">Anterior</Button>
        <Button disabled={idx === quiz.questions.length - 1} onClick={() => setIdx(idx + 1)} className="rounded-full bg-brand-blue hover:bg-blue-700">Próxima</Button>
      </div>
    </DashboardLayout>
  );
}
